"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = chooseFootnotes;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var _getContentArea = _interopRequireDefault(require("../page/getContentArea"));
var _getFootnotePlaceholder = _interopRequireDefault(require("./getFootnotePlaceholder"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getHeight = R.path(['box', 'height']);
var FOOTNOTES_MIN_HEIGHT = 15;
var groupByKey = function groupByKey(array, key) {
  return Object.values(array.reduce(function (r, a) {
    var groups = r;
    groups[a[key]] = groups[a[key]] || [];
    groups[a[key]].push(a);
    return groups;
  }, {}));
};
var chooseToFitHeight = function chooseToFitHeight(group, height) {
  var chosen = [];
  var totalHeight = 0;
  for (var i = 0; i < group.length; i += 1) {
    var note = group[i];
    if (totalHeight + note.heightNeeded > height) {
      break;
    }
    chosen.push(note);
    totalHeight += note.heightNeeded;
  }
  return chosen;
};
/**
 * Given page, choose which footnotes to include in the page considering,
 *
 *  1. If the footnote is included, will the reference to the footnote be on the same page,
 *  2. If not, will the reference move back to the page given more space being available
 *  3. If we can't fit the line including the references and footnotes in the same page,
 *     we will limit the no of footnotes shown to available space
 *
 *  If case 2 is happening we need to limit he content height for that page so that,
 *  the reference won't move back to the previous page.
 *  For that, this function also returns a space that needs added to the
 *
 * @param {page} page
 *
 * @returns {Object} containing footnotes array and contentHeight
 */
function chooseFootnotes(page, footnotes) {
  var contentArea = (0, _getContentArea.default)(page);
  var footnotesHeight = FOOTNOTES_MIN_HEIGHT;
  var spacingNeeded = 0;
  var chosenFootnotes = [];
  var placeholder = (0, _getFootnotePlaceholder.default)(page);
  if (placeholder) {
    var getFootnoteView = function getFootnoteView(a) {
      return placeholder.children[0].children[a + 1];
    };
    var initialFootnotes = footnotes.map(function (e, index) {
      var footnoteView = getFootnoteView(index);
      var footnoteHeight = getHeight(footnoteView) + footnoteView.box.marginBottom + footnoteView.box.marginTop;
      return (0, _extends2.default)({}, e, {
        heightNeeded: footnoteHeight,
        footnoteView: footnoteView
      });
    });
    var groupedFootnotes = groupByKey(initialFootnotes, 'approxTop');
    groupedFootnotes = groupedFootnotes.map(function (e) {
      return {
        footnoteGroup: e,
        groupTop: e[0].approxTop - page.box.paddingTop,
        groupBottom: e[0].approxBottom - page.box.paddingTop,
        totalHeight: e.reduce(function (a, b) {
          return a + b.heightNeeded;
        }, 0),
        breakAfter: e[0].breakAfter
      };
    });
    var _loop = function _loop() {
      var _groupedFootnotes$i = groupedFootnotes[i],
        totalHeight = _groupedFootnotes$i.totalHeight,
        footnoteGroup = _groupedFootnotes$i.footnoteGroup,
        groupBottom = _groupedFootnotes$i.groupBottom,
        groupTop = _groupedFootnotes$i.groupTop,
        breakAfter = _groupedFootnotes$i.breakAfter;
      var lineHeight = groupBottom - groupTop;
      var spaceAfterAdding = contentArea - footnotesHeight - totalHeight - groupBottom;

      // include footnotes if space is available
      if (spaceAfterAdding > lineHeight || spaceAfterAdding > 0 && breakAfter) {
        var _chosenFootnotes;
        footnotesHeight += totalHeight;
        (_chosenFootnotes = chosenFootnotes).push.apply(_chosenFootnotes, footnoteGroup);
      }

      // case where space is not enough to include all the notes
      else {
        var availableSpace = contentArea - groupBottom - footnotesHeight;
        // keep at least 2 lines to avoid triggering widow / orphan
        var minContentSpace = Math.ceil(lineHeight * 2);
        /* 
          if the references and the footnotes height total is greater than the page,
          show the footnotes in the available space and discard others
        */
        if (minContentSpace + totalHeight > contentArea) {
          if (groupBottom >= minContentSpace) {
            // if the references are below the minimum possible content size,
            // shift the footnotes refs to the first line of next page
            spacingNeeded = Math.ceil(contentArea - groupTop - footnotesHeight);
          } else {
            var _chosenFootnotes2;
            // if the refs are within the minimum content size, show what is possible & cut off others.
            var chosen = chooseToFitHeight(footnoteGroup, availableSpace);
            (_chosenFootnotes2 = chosenFootnotes).push.apply(_chosenFootnotes2, chosen);
            footnotesHeight += chosen.reduce(function (a, b) {
              return a + b.heightNeeded;
            }, 0);
            spacingNeeded = contentArea - Math.max(groupBottom, minContentSpace) - footnotesHeight;
          }
        } else {
          // filter footnotes that will be shifted due to orphan / widow protection
          chosenFootnotes = chosenFootnotes.filter(function (note) {
            // bottom of the line containing the note reference
            var noteBottom = note.approxBottom - page.box.paddingTop;
            // height between current groupTop(shift point) and note bottom
            var spaceAfter = groupTop - noteBottom;
            // if the line is the last line, a break should be allowed after it to include it
            return spaceAfter > lineHeight || note.breakAfter;
          });

          // if they can be included in a single page add a space and shift the reference to next page
          spacingNeeded = contentArea - groupTop - (chosenFootnotes.length > 0 ? footnotesHeight : 0);
        }
        return 1; // break
      }
    };
    for (var i = 0; i < groupedFootnotes.length; i += 1) {
      if (_loop()) break;
    }
  }
  return {
    footnotes: chosenFootnotes,
    spacingNeeded: Math.floor(Math.max(0, spacingNeeded))
  };
}